/**
 * EINE Entscheidung über Indexierbarkeit — benutzt von
 *   1. `scripts/prerender-seo.js` (das ausgelieferte, rohe HTML)
 *   2. `SeoLandingPage` → `useSeoHead` (das gerenderte DOM)
 *
 * Vorher schrieb der Prerender pauschal `index, follow`, während die
 * Seite nach dem Laden `noindex` setzen konnte — rohes HTML und
 * gerendertes DOM widersprachen sich. Beide Wege benutzen jetzt diese
 * Datei; die Schwelle kommt aus der Registry (`min_results`), also aus
 * derselben Quelle wie das Sitemap-Gate im Backend.
 *
 * CommonJS, weil das Build-Skript unter Node läuft und dieselbe Datei
 * laden muss (Webpack und Jest importieren CJS unverändert).
 */
const ROBOTS_INDEX = "index, follow";
const ROBOTS_NOINDEX = "noindex, follow";

const STATE_INDEX = "index";
const STATE_THIN = "thin";
const STATE_UNKNOWN = "unknown";

/**
 * @param {number|null|undefined} count  echte Trefferzahl oder `null`,
 *   wenn sie (noch) nicht bekannt ist: Ladefehler, Zähler-Timeout
 *   (`meta.total_unavailable`) oder Ladevorgang läuft noch.
 * @param {number} minResults  Schwelle der Seite aus der Registry.
 */
function seoIndexState(count, minResults) {
  if (count === null || count === undefined || count === "") {
    return STATE_UNKNOWN;
  }
  const n = Number(count);
  const min = Number(minResults);
  if (!Number.isFinite(n) || !Number.isFinite(min)) return STATE_UNKNOWN;
  return n >= min ? STATE_INDEX : STATE_THIN;
}

/**
 * Nachweislich zu dünn → `noindex, follow`.
 *
 * Unbekannt wird NICHT gesperrt, und zwar bewusst: ein `noindex` im
 * rohen HTML kann die Laufzeit nicht mehr aufheben, falls ein Crawler
 * kein JavaScript ausführt — ein Zählerausfall zur Bauzeit würde also
 * alle Einstiegsseiten dauerhaft aus dem Index nehmen. Der umgekehrte
 * Fall korrigiert sich selbst: sobald die echte Trefferzahl vorliegt,
 * setzt die Seite `noindex`. Die Sitemap bleibt dagegen streng — dort
 * ist ein Eintrag eine aktive Einreichung, keine Zulassung.
 */
function seoRobots(state) {
  return state === STATE_THIN ? ROBOTS_NOINDEX : ROBOTS_INDEX;
}

module.exports = {
  ROBOTS_INDEX,
  ROBOTS_NOINDEX,
  STATE_INDEX,
  STATE_THIN,
  STATE_UNKNOWN,
  seoIndexState,
  seoRobots,
};
